"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgEdit2 = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M31.992 13.13a3.828 3.828 0 011.716 6.406l-13.5 13.5a1 1 0 01-.444.257l-5.5 1.5a1 1 0 01-1.228-1.228l1.5-5.5a1 1 0 01.258-.444l13.5-13.5a3.828 3.828 0 013.698-.99zm.302 4.991a1.828 1.828 0 00-2.586-2.585L16.396 28.848l-.97 3.555 3.556-.97 13.312-13.312z",
    id: "edit-2_svg__a"
  }));
};

var _default = SvgEdit2;
exports.default = _default;